const esc = (s = "") =>
  String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const nl2br = (s = "") => esc(s).replace(/\n/g, "<br/>");

const dateRange = (a, b) => [a, b].filter(Boolean).join(" – ");

// Render a link as its full, readable URL (e.g. "linkedin.com/in/username")
// rather than a label — strip the scheme and any trailing slash.
const prettyUrl = (s = "") => String(s).replace(/^https?:\/\//i, "").replace(/\/+$/, "");
const linkFull = (url) =>
  url ? `<a href="${esc(url)}">${esc(prettyUrl(url))}</a>` : "";

const section = (title, body) =>
  body && body.trim() ? `<section><h2>${title}</h2>${body}</section>` : "";

function renderHeader(r) {
  const locParts = [r.location, r.state, r.country].filter(Boolean).join(", ");
  const links = [
    linkFull(r.website),
    linkFull(r.linkedin),
    linkFull(r.github),
    linkFull(r.portfolio),
  ].filter(Boolean).join(" · ");
  const contact = [r.email, r.phone, locParts].filter(Boolean).join("  ·  ");
  return `
  <header>
    <h1>${esc(r.full_name || "Your Name")}</h1>
    ${r.headline ? `<div class="headline">${esc(r.headline)}</div>` : ""}
    ${contact ? `<div class="contact">${esc(contact)}</div>` : ""}
    ${links ? `<div class="links">${links}</div>` : ""}
  </header>`;
}

function renderExperience(r) {
  return (r.experience || [])
    .filter((e) => e.company || e.title)
    .map(
      (e) => `
      <div class="item">
        <div class="row">
          <span class="strong">${esc(e.title || "")}${e.company ? `, ${esc(e.company)}` : ""}</span>
          <span class="muted">${esc(dateRange(e.start_date, e.end_date))}</span>
        </div>
        ${e.location ? `<div class="muted small">${esc(e.location)}</div>` : ""}
        ${e.description ? `<div class="desc">${nl2br(e.description)}</div>` : ""}
      </div>`
    )
    .join("");
}

function renderEducation(r) {
  return (r.education || [])
    .filter((e) => e.school || e.degree)
    .map(
      (e) => `
      <div class="item">
        <div class="row">
          <span class="strong">${esc(e.degree || "")}${e.school ? `, ${esc(e.school)}` : ""}</span>
          <span class="muted">${esc(dateRange(e.start_date, e.end_date))}</span>
        </div>
        ${e.location ? `<div class="muted small">${esc(e.location)}</div>` : ""}
      </div>`
    )
    .join("");
}

function renderTextSection(title, value) {
  return section(title, value ? `<p>${nl2br(value)}</p>` : "");
}

export function buildResumeHtml(r) {
  return `<!doctype html>
<html>
<head>
<meta charset="utf-8"/>
<title>${esc(r.full_name || "Resume")}</title>
<style>
  @page { size: A4; margin: 18mm; }
  * { box-sizing: border-box; }
  body { font-family: Georgia, "Times New Roman", serif; color: #18181b; line-height: 1.45; margin: 0; }
  header { border-bottom: 2px solid #18181b; padding-bottom: 10px; margin-bottom: 16px; }
  h1 { font-family: Arial, Helvetica, sans-serif; font-size: 26px; margin: 0 0 4px; letter-spacing: -0.5px; }
  .headline { font-family: Arial, Helvetica, sans-serif; font-size: 13px; color: #3f3f46; margin-bottom: 8px; }
  .contact, .links { font-size: 11px; color: #3f3f46; }
  .links a { color: #18181b; text-decoration: none; }
  h2 { font-family: Arial, Helvetica, sans-serif; font-size: 12px; text-transform: uppercase; letter-spacing: 1.5px; border-bottom: 1px solid #d4d4d8; padding-bottom: 3px; margin: 18px 0 8px; }
  section { page-break-inside: avoid; }
  .item { margin-bottom: 10px; }
  .row { display: flex; justify-content: space-between; gap: 12px; }
  .strong { font-weight: bold; font-size: 13px; }
  .muted { color: #52525b; font-size: 11px; }
  .small { font-size: 10.5px; }
  .desc { font-size: 12px; margin-top: 3px; white-space: normal; }
  p { font-size: 12px; margin: 0; white-space: pre-wrap; }
</style>
</head>
<body>
  ${renderHeader(r)}
  ${renderTextSection("Summary", r.summary)}
  ${renderTextSection("Skills", r.skills)}
  ${section("Experience", renderExperience(r))}
  ${section("Education", renderEducation(r))}
  ${renderTextSection("Projects", r.projects)}
</body>
</html>`;
}
